<template>
  <div class="app-wrapper">
    <NavigationVue />

    <div class="container">
      <router-view />
      <RightPanel v-if="showRightPanel" />
    </div>
    <CandidateImportTypeDialog
      v-if="
        is_visible.candidate_import_type_dialog &&
        dialogMetaData &&
        dialogMetaData.panels
      "
      :metaData="dialogMetaData"
      :is_visible="is_visible.candidate_import_type_dialog"
      @cancel-callback="closeDialog('candidate_import_type_dialog')"
    />
    <CandidateImportDialog
      v-if="
        is_visible.candidate_import_dialog_single ||
        is_visible.candidate_import_dialog_multi
      "
      :is_visible="
        is_visible.candidate_import_dialog_single ||
        is_visible.candidate_import_dialog_multi
      "
      :mode="
        is_visible.candidate_import_dialog_single == true ? 'single' : 'multi'
      "
      @cancel-callback="
        closeDialog(
          is_visible.candidate_import_dialog_single == true
            ? 'candidate_import_dialog_single'
            : 'candidate_import_dialog_multi'
        )
      "
    />
    <SingleGeneralDialog
      v-if="dialogVisible && dialogMetaData && dialogMetaData.panels"
      :metaData="dialogMetaData"
    />
    <MassSaveResumeProgressDialog
      v-if="is_visible.mass_save_resume_progress_dialog"
      :is_visible="is_visible.mass_save_resume_progress_dialog"
    />
    <GeneralDialog
      v-if="is_visible.general_dialog.display"
      :is_visible="is_visible.general_dialog.display"
      @reset-callback="closeCurrentDialog('general_dialog')"
      @cancel-callback="closeCurrentDialog('general_dialog')"
      @change-stage="
        changeStage(is_visible.general_dialog.intents, 'general_dialog')
      "
    >
      <EventEditDialog
        :is_visible="true"
        :isDialog="false"
        :data="selectedEvent"
      />
    </GeneralDialog>
    <Dialog
      v-if="is_visible.stage_dialog.display"
      :is_visible="is_visible.stage_dialog.display"
      title="Перевод на этап"
      :text="`Вы действительно хотите сменить этап подбора на «${stageName}»?`"
      @ok-callback="
        changeStage(is_visible.stage_dialog.intents, 'stage_dialog')
      "
      @cancel-callback="closeCurrentDialog('stage_dialog')"
    />
    <Dialog
      v-if="is_visible.merge_dublicate_dialog"
      title="Объединить кандидатов?"
      text="При объединении дубликатов действие нельзя будет отменить"
      :is_visible="is_visible.merge_dublicate_dialog"
      button-ok-color="blue"
      button-cancel-color="darkBlue"
      @ok-callback="mergeDublicate"
      @cancel-callback="closeCurrentDialog('merge_dublicate_dialog')"
    />
    <ConfirmCloseDialog
      v-if="is_visible.confirm_close_dialog.display"
      :is_visible="is_visible.confirm_close_dialog.display"
      @reset-callback="confirmCloseDialog(null, false)"
    />
    <EventEditDialog
      v-if="is_visible.create_event_dialog_empty"
      :is_visible="is_visible.create_event_dialog_empty"
      :data="null"
      @reset-callback="
        {
          closeDialog('create_event_dialog_empty', null);
          selectedEvent = null;
        }
      "
      @confirm-close="p => confirmCloseDialog(p, true)"
    />
    <WarningSBDialog
      v-if="
        is_visible.warning_sb_dialog?.display &&
        is_visible.warning_sb_dialog?.data?.show
      "
      :is_visible="is_visible.warning_sb_dialog.display"
      @cancel-callback="closeCurrentDialog('warning_sb_dialog')"
    />
    <PushNotifications />
  </div>
</template>
<script>
import { store } from '@/store';
import { mixin, dialogMixin, errorMsg } from '@/utils/mixins';
import NavigationVue from 'Elements/NavigationBar/Navigation';
import RightPanel from 'Elements/Panel/RightPanel';
import SingleGeneralDialog from 'Elements/Dialog/SingleGeneralDialog';
import GeneralDialog from 'Elements/Dialog/GeneralDialog';
import Dialog from 'Elements/Dialog/Dialog';
import CandidateImportTypeDialog from 'Elements/Dialog/CandidateImportTypeDialog';
import CandidateImportDialog from 'Elements/Dialog/CandidateImportDialog';
import MassSaveResumeProgressDialog from 'Elements/Dialog/MassSaveResumeProgressDialog';
import EventEditDialog from 'Elements/Dialog/EventEditDialog';
import ConfirmCloseDialog from 'Elements/Dialog/ConfirmCloseDialog';
import WarningSBDialog from 'Elements/Dialog/WarningSBDialog';
import PushNotifications from 'Elements/Push/PushNotifications';
import { getController } from '@/controllers/request.js';
import { INTENT_AREA, MODULE } from '@/utils/constants';

export default {
  mixins: [mixin, dialogMixin, errorMsg],
  data() {
    return {};
  },
  computed: {
    stageName() {
      const stage = store.state.candidate.selectedStage;
      return stage &&
        stage.fields[0] &&
        stage.fields[0].schema &&
        stage.fields[0].schema.stage_name
        ? stage.fields[0].schema.stage_name.text ||
            stage.fields[0].schema.stage_name
        : 'неизвестно';
    },
    selectedVacancyCandidate() {
      return store.state.vacancy.currentVacancyCandidate || null;
    },
    selectedEvent: {
      get() {
        return (
          store.state.candidate.selectedMeeting || {
            hrpac_candidate_id: this.fields.id
          }
        );
      },
      set(val) {
        store.commit('candidate/setSelectedMeeting', val);
      }
    },
    fields() {
      return store.state.candidate.metadata?.bean || {};
    },
    dialogVisible() {
      return store.state.dialog.singleDialogVisible;
    },
    dialogMetaData() {
      return store.state.dialog.dialogData;
    },
    is_visible() {
      return store.state.common.visible_dialog;
    },
    selectedStage() {
      return store.state.candidate.selectedStage || null;
    },
    showRightPanel() {
      return Boolean(store.state.rightPanel.panelMode);
    }
  },
  methods: {
    closeCurrentDialog(name) {
      store.commit('common/setVisibleDialog', {
        name: name,
        val: false,
        [name == 'warning_sb_dialog' ? 'data' : 'params']:
          name == 'warning_sb_dialog' ? {} : []
      });
      store.commit('dialog/setLoading', false);
    },
    async mergeDublicate() {
      const intent = {
        intentArea: 'Popup',
        intentType: 'confirm',
        module: 'HRPAC_CANDIDATES_DUPLICATES',
        request: {
          url: '/index.php?module=HRPAC_CANDIDATES_DUPLICATES&action=mergeDuplicateToCandidate',
          request_params: {
            parent_id: this.$route.params.id,
            duplicate_id: this.$route.params.dublicateId
          }
        },
        size: 'S'
      };
      try {
        store.commit('dialog/setLoading', true);
        const { data } = await mixin.methods.sendFormRequestFromIntent(intent);
        if (data.intents?.length) {
          const record =
            data.intents?.[0]?.request?.request_params?.record ??
            this.$route.params.id;
          this.$router.push({ name: 'candidateId', params: { id: record } });
        }
        if (data?.status == 'error') {
          errorMsg.methods.showNotification({
            offset: 100,
            showClose: true,
            message: data?.error?.error_text?.error || 'Ошибка',
            duration: 6500,
            type: 'error'
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        store.commit('dialog/setLoading', false);
      }
    },
    async changeStage(intents, dialogName) {
      if (intents?.length) {
        for (let i = 0; i < intents.length; i++) {
          if (intents[i].intentArea == INTENT_AREA.AJAX) {
            let url = intents[i].request.url;

            for (let key in intents[i].request?.request_params) {
              url += `&${key}=${intents[i].request.request_params[key]}`;
            }

            try {
              const response = await getController({
                url
              });

              if (
                response?.data?.errors &&
                Array.isArray(response.data.errors) &&
                response?.data?.errors?.length > 0
              ) {
                for (let i = 0; i < response.data.errors.length; i++) {
                  this.catchError({}, response.data.errors[i]);
                }
              } else if (
                response?.data?.status &&
                response?.data?.errors?.title &&
                response?.data?.status == 'error'
              ) {
                this.catchError({}, response.data.errors.title);
              } else if (
                this.$route.meta.module == MODULE.VACANCY_MODULE &&
                this.$route.params.id
              ) {
                if (this.selectedVacancyCandidate) {
                  //при смене этапа кандидата из карточки вакансии
                  //меняем данные этапа в выбранном кандидате
                  const tableData =
                    store.state.common.tableData?.vacancy_candidates?.rows;
                  let neededRow = null;
                  for (let i in tableData) {
                    if (
                      tableData[i]['ID'] != this.selectedVacancyCandidate['ID']
                    ) {
                      continue;
                    } else {
                      neededRow = tableData[i];
                      neededRow['CURRENT_STAGE_NAME'] = this.stageName;
                      neededRow['CURRENT_STAGE_ID'] =
                        this.selectedVacancyCandidate['ID'];
                      this.$set(
                        store.state.common.tableData?.vacancy_candidates?.rows,
                        i,
                        neededRow
                      );
                      break;
                    }
                  }
                  //если мы переводим кандидата на этап "Принят",
                  //то обновляем кол-во позиций в метаданных вкладки Описание,
                  //если они уже были загружены
                  if (
                    this.stageName == 'Принят' &&
                    store.state.subpanels.activeSubpanelData.hasOwnProperty(
                      'description'
                    )
                  ) {
                    let positionCount =
                      store.state.subpanels.activeSubpanelData.description
                        .metadata.top_custom_panels.amount_final.value;
                    store.state.subpanels.activeSubpanelData.description.metadata.top_custom_panels.amount_final.value =
                      (Number(positionCount) - 1).toString();
                  }
                  store.commit('vacancy/setParam', {
                    name: 'currentVacancyCandidate',
                    val: this.selectedVacancyCandidate
                  });
                }
              }

              store.commit('common/setVisibleDialog', {
                name: dialogName,
                val: false
              });
              store.commit('dialog/setLoading', false);
              store.commit('common/setRemoveGeneralDialog');
            } catch (err) {
              this.catchError(
                err,
                err || 'Возникла ошибка при переводе на этап'
              );
            }
          } else if (intents[i].intentArea == INTENT_AREA.RIGHT_PANEL) {
            store.dispatch('rightPanel/getMetadata', {
              intentOrRequest: intents[i].request
            });
          } else if (intents[i].intentArea == INTENT_AREA.DYNAMIC_PAGE) {
            if (intents[i].request?.request_params?.module == 'HRPAC_VACANCY') {
              const id = intents[i].request?.request_params?.record || '';
              store.dispatch('vacancy/getMetadata', id);
            }
          }
        }
      } else {
        store.commit('common/setVisibleDialog', {
          name: 'general_dialog',
          val: false
        });
        store.commit('dialog/setLoading', false);
      }
    }
  },
  components: {
    NavigationVue,
    RightPanel,
    SingleGeneralDialog,
    GeneralDialog,
    Dialog,
    CandidateImportTypeDialog,
    CandidateImportDialog,
    MassSaveResumeProgressDialog,
    EventEditDialog,
    ConfirmCloseDialog,
    WarningSBDialog,
    PushNotifications
  }
};
</script>

<style lang="scss" scoped>
.app-wrapper {
  display: flex;
  height: calc(100vh - 40px);
  margin: 16px 24px 24px 96px;
  box-sizing: border-box;
}
.container {
  width: 100%;
  min-width: 875px;
  overflow: hidden;
  box-sizing: border-box;
  margin: 0 auto;
  position: relative;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@media (min-width: 1513px) {
  .container {
    max-width: 1392px;
  }
}

@media (min-width: 1200px) and (max-width: 1512px) {
  .container {
    max-width: 1080px;
  }
}
</style>
